import stamp from '../api/stampRequest1'
//withdrawStamp
export const getNavReport = (data) => async (dispatch) =>{
  const resp = await stamp(dispatch).post(`/Report/InvoicingDailyReport`,data)
  return resp.data
}